/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePublicProfileDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type playerProfileGetByNameResponse200 = {
  data: ApiEnvelopePublicProfileDto
  status: 200
}

export type playerProfileGetByNameResponse404 = {
  data: ApiEnvelopePublicProfileDto
  status: 404
}

export type playerProfileGetByNameResponseSuccess = (playerProfileGetByNameResponse200) & {
  headers: Headers;
};
export type playerProfileGetByNameResponseError = (playerProfileGetByNameResponse404) & {
  headers: Headers;
};

export type playerProfileGetByNameResponse = (playerProfileGetByNameResponseSuccess | playerProfileGetByNameResponseError)

export const getPlayerProfileGetByNameUrl = (name: string,) => {




  return `/api/playerprofile/by-name/${name}`
}

export const usePlayerProfileGetByNameHook = (): (name: string, options?: RequestInit) => Promise<playerProfileGetByNameResponse> => {

      const customFetcher = useSfetchMutator();
      return (name: string, options?: RequestInit) => {

        return customFetcher(getPlayerProfileGetByNameUrl(name),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type playerProfileGetByUuidResponse200 = {
  data: ApiEnvelopePublicProfileDto
  status: 200
}

export type playerProfileGetByUuidResponse404 = {
  data: ApiEnvelopePublicProfileDto
  status: 404
}

export type playerProfileGetByUuidResponseSuccess = (playerProfileGetByUuidResponse200) & {
  headers: Headers;
};
export type playerProfileGetByUuidResponseError = (playerProfileGetByUuidResponse404) & {
  headers: Headers;
};

export type playerProfileGetByUuidResponse = (playerProfileGetByUuidResponseSuccess | playerProfileGetByUuidResponseError)

export const getPlayerProfileGetByUuidUrl = (uuid: string,) => {




  return `/api/playerprofile/by-uuid/${uuid}`
}

export const usePlayerProfileGetByUuidHook = (): (uuid: string, options?: RequestInit) => Promise<playerProfileGetByUuidResponse> => {

      const customFetcher = useSfetchMutator();
      return (uuid: string, options?: RequestInit) => {

        return customFetcher(getPlayerProfileGetByUuidUrl(uuid),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


